import TabCoaches from "@/views/App/Dashboard/HeadPsychosocialServices/TabCoaches.vue";
import TabInfo from "@/views/App/Dashboard/HeadPsychosocialServices/TabInfo.vue";
import TabPotentialUnits from "@/views/App/Dashboard/HeadPsychosocialServices/TabPotentialUnits.vue";
import TabUnitsDoneByLocation from "@/views/App/Dashboard/HeadPsychosocialServices/TabUnitsDoneByLocation.vue";
import UnsignedUnitsLocation from "@/views/App/Dashboard/HeadPsychosocialServices/UnsignedUnitsLocation.vue";


const routesDashboardHeadPsychosocialServices = [
    {
        path: 'info',
        name: 'dashboardHeadPsychosocialServicesInfo',
        component: TabInfo
    },
    {
        path: 'coaches',
        name: 'dashboardHeadPsychosocialServicesCoaches',
        component: TabCoaches
    },
    {
        path: 'potential-units',
        name: 'dashboardHeadPsychosocialServicesPotentialUnits',
        component: TabPotentialUnits
    },
    {
        path: 'units-done-by-location',
        name: 'dashboardHeadPsychosocialServicesUnitsDoneByLocation',
        component: TabUnitsDoneByLocation
    },
    {
        path: 'unsigned-units-location/:locationId',
        name: 'dashboardHeadPsychosocialServicesUnsignedUnitsLocation',
        component: UnsignedUnitsLocation
    }
  ];

export default routesDashboardHeadPsychosocialServices;